(function () {
  'use strict';

  const SEE_MORE_LIMIT = 5;

  function initVariantFilters() {
    const grid = document.getElementById('HousiousProductGrid');
    const groupsContainer = document.getElementById(
      'DynamicVariantFilterGroups'
    );

    if (!grid || !groupsContainer) return;

    const filterRoot = document.getElementById('DynamicVariantFilters');
    const selected = new Map();

    function getProducts() {
      return Array.from(
        grid.querySelectorAll('.collection-variant-product')
      ).map((element) => {
        try {
          return {
            element,
            options: JSON.parse(
              element.dataset.productOptions || '[]'
            ),
            variants: JSON.parse(
              element.dataset.productVariants || '[]'
            )
          };
        } catch (error) {
          return {
            element,
            options: [],
            variants: []
          };
        }
      });
    }

    function buildFilters() {
      const products = getProducts();
      const optionGroups = new Map();

      products.forEach((product) => {
        product.options.forEach((optionName, index) => {
          if (!optionGroups.has(optionName)) {
            optionGroups.set(optionName, new Map());
          }

          const values = optionGroups.get(optionName);

          product.variants.forEach((variant) => {
            const value = variant.options
              ? variant.options[index]
              : null;

            if (value == null || value === '') return;

            if (!values.has(value)) {
              values.set(value, new Set());
            }

            values.get(value).add(product.element);
          });
        });
      });

      groupsContainer.replaceChildren();

      if (optionGroups.size === 0) {
        filterRoot.hidden = true;
        return;
      }

      filterRoot.hidden = false;

      optionGroups.forEach((values, optionName) => {
        const block = document.createElement('div');
        block.className = 'filter-group-block dynamic-variant-option';

        const heading = document.createElement('h4');
        heading.className = 'filter-group-title';
        heading.textContent = optionName;

        const list = document.createElement('ul');
        list.className = 'filter-checkbox-list';

        let itemIndex = 0;
        let hasCheckedInExtra = false;

        // First pass to check if any item in the "extra" section is checked
        values.forEach((productSet, value) => {
          itemIndex++;
          if (itemIndex > SEE_MORE_LIMIT) {
            if ((selected.get(optionName) || new Set()).has(value)) {
              hasCheckedInExtra = true;
            }
          }
        });

        itemIndex = 0;
        let extraItems = [];

        values.forEach((productSet, value) => {
          itemIndex++;

          const item = document.createElement('li');
          const label = document.createElement('label');
          label.className = 'filter-checkbox-label';

          const checkbox = document.createElement('input');
          checkbox.type = 'checkbox';
          checkbox.className = 'filter-checkbox-input js-variant-filter';
          checkbox.dataset.option = optionName;
          checkbox.value = value;

          checkbox.checked = (
            selected.get(optionName) || new Set()
          ).has(value);

          const text = document.createElement('span');
          text.className = 'custom-checkbox-text';
          text.textContent = value;

          const count = document.createElement('span');
          count.className = 'filter-item-count';
          count.textContent = `(${productSet.size})`;

          label.append(checkbox, text, count);
          item.append(label);

          if (itemIndex > SEE_MORE_LIMIT) {
            item.style.display = hasCheckedInExtra ? '' : 'none';
            item.classList.add('hidden-variant-item');
            extraItems.push(item);
          }

          list.append(item);
        });

        block.append(heading, list);

        if (values.size > SEE_MORE_LIMIT) {
          const remaining = values.size - SEE_MORE_LIMIT;
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'view-more-link';
          btn.dataset.expanded = hasCheckedInExtra ? 'true' : 'false';
          btn.style.cssText = 'background: none; border: none; color: #721033; padding: 0; font-weight: 600; cursor: pointer; margin-top: 10px;';
          btn.textContent = hasCheckedInExtra ? `- View Less` : `+ View More (${remaining})`;

          btn.addEventListener('click', () => {
            const isExpanded = btn.dataset.expanded === 'true';
            btn.dataset.expanded = isExpanded ? 'false' : 'true';
            btn.textContent = isExpanded ? `+ View More (${remaining})` : `- View Less`;

            extraItems.log;
            extraItems.forEach((li) => {
              li.style.display = isExpanded ? 'none' : '';
            });
          });

          block.append(btn);
        }

        groupsContainer.append(block);
      });

      applyFilters();
    }

    function applyFilters() {
      const products = getProducts();

      products.forEach((product) => {
        let matches = true;

        selected.forEach((selectedValues, optionName) => {
          if (selectedValues.size === 0) return;

          const optionIndex = product.options.indexOf(optionName);

          if (optionIndex === -1) {
            matches = false;
            return;
          }

          const matchingVariant = product.variants.some((variant) => {
            const value = variant.options
              ? variant.options[optionIndex]
              : null;

            return selectedValues.has(value);
          });

          if (!matchingVariant) matches = false;
        });

        product.element.hidden = !matches;
      });

      const visibleCount = products.filter(
        (product) => !product.element.hidden
      ).length;

      const countElement = document.getElementById(
        'LoadedProductsCount'
      );

      if (countElement) {
        countElement.textContent = visibleCount;
      }
    }

    groupsContainer.addEventListener('change', (event) => {
      const checkbox = event.target.closest('.js-variant-filter');
      if (!checkbox) return;

      const optionName = checkbox.dataset.option;

      if (!selected.has(optionName)) {
        selected.set(optionName, new Set());
      }

      const values = selected.get(optionName);

      if (checkbox.checked) {
        values.add(checkbox.value);
      } else {
        values.delete(checkbox.value);
      }

      if (values.size === 0) {
        selected.delete(optionName);
      }

      applyFilters();
    });

    const clearAll = document.getElementById('ClearAllFilters');

    if (clearAll) {
      clearAll.addEventListener('click', () => {
        selected.clear();
      });
    }

    buildFilters();

    let rebuildTimeout;

    const observer = new MutationObserver(() => {
      clearTimeout(rebuildTimeout);

      rebuildTimeout = setTimeout(() => {
        buildFilters();
      }, 100);
    });

    observer.observe(grid, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initVariantFilters
    );
  } else {
    initVariantFilters();
  }
})();